import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
// import { useSelector} from "react-redux";


const ErrorPage = () => {
  // const { isLoggedIn } = useSelector((state) => state.auth);
  // const [previousURL, setPreviousURL] = useState("/");

  // Navigate to home after 4sec if page not found
  useEffect(() => {
    const timer = setTimeout(() => {
        window.history.back(); // Go back to the previous page
      }, 4000);
    return () => clearTimeout(timer);
  });

  return (
    <Container className="mb-0">
      <Row>
        <Col
          sm={12}
          lg={6}
          className="d-flex flex-column align-items-center justify-content-center   text-center mx-auto"
        >
          <h1 className="display-1 fw-bold mb-4">404</h1>
          <p className="fs-3 mb-1">
            {" "}
            <span className="text-danger">Opps!</span> Page not found.
          </p>
          <p className="lead mb-4">
            The page you’re looking for doesn’t exist.
          </p>
          <Button href="/" className="btn button-purple-solid btn-lg-150">
            Go Home
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
export default ErrorPage;
